import { Link } from "react-router";
import { MapPin } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { usePermissao } from "@/lib/use-permissao";

/**
 * Organização criada antes de o endereço ser obrigatório fica sem ele — e pedido de prótese sem
 * endereço não tem pra onde voltar nem etiqueta de entrega. Avisa no Início quem pode cadastrar.
 */
export function AvisoDeEndereco() {
  const podeConfigurar = usePermissao("settings.manage");
  const perfil = trpc.organization.getProfiles.useQuery(undefined, { enabled: podeConfigurar });
  if (!podeConfigurar || !perfil.data || perfil.data.mainAddress?.address) return null;

  return (
    <div className="mb-4 flex flex-wrap items-center gap-3 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5 text-[12.5px] text-amber-900 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-200">
      <MapPin className="h-4 w-4 shrink-0" />
      <p className="min-w-0 flex-1">
        <strong>Endereço pendente.</strong> Cadastre o endereço de {perfil.data.name} para enviar pedidos de
        prótese: ele é usado nas etiquetas de entrega e como destino dos trabalhos concluídos.
      </p>
      <Link
        to="/configuracoes/dados"
        className="inline-flex h-8 shrink-0 items-center rounded-md bg-amber-600 px-3 text-[12px] font-semibold text-white transition-colors hover:bg-amber-700"
      >
        Cadastrar endereço
      </Link>
    </div>
  );
}
